var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "20*20",
    clipPath: "url(#clip0_52_816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.6665 4.16665C6.6665 4.38766 6.7543 4.59962 6.91058 4.7559C7.06686 4.91218 7.27882 4.99998 7.49984 4.99998C7.72085 4.99998 7.93281 4.91218 8.08909 4.7559C8.24537 4.59962 8.33317 4.38766 8.33317 4.16665C8.33317 3.94563 8.24537 3.73367 8.08909 3.57739C7.93281 3.42111 7.72085 3.33331 7.49984 3.33331C7.27882 3.33331 7.06686 3.42111 6.91058 3.57739C6.7543 3.73367 6.6665 3.94563 6.6665 4.16665Z",
    stroke: "#6C59E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.6665 10C6.6665 10.221 6.7543 10.433 6.91058 10.5893C7.06686 10.7456 7.27882 10.8334 7.49984 10.8334C7.72085 10.8334 7.93281 10.7456 8.08909 10.5893C8.24537 10.433 8.33317 10.221 8.33317 10C8.33317 9.77901 8.24537 9.56705 8.08909 9.41076C7.93281 9.25448 7.72085 9.16669 7.49984 9.16669C7.27882 9.16669 7.06686 9.25448 6.91058 9.41076C6.7543 9.56705 6.6665 9.77901 6.6665 10Z",
    stroke: "#6C59E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.6665 15.8333C6.6665 16.0543 6.7543 16.2663 6.91058 16.4226C7.06686 16.5789 7.27882 16.6667 7.49984 16.6667C7.72085 16.6667 7.93281 16.5789 8.08909 16.4226C8.24537 16.2663 8.33317 16.0543 8.33317 15.8333C8.33317 15.6123 8.24537 15.4004 8.08909 15.2441C7.93281 15.0878 7.72085 15 7.49984 15C7.27882 15 7.06686 15.0878 6.91058 15.2441C6.7543 15.4004 6.6665 15.6123 6.6665 15.8333Z",
    stroke: "#6C59E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6665 4.16665C11.6665 4.38766 11.7543 4.59962 11.9106 4.7559C12.0669 4.91218 12.2788 4.99998 12.4998 4.99998C12.7209 4.99998 12.9328 4.91218 13.0891 4.7559C13.2454 4.59962 13.3332 4.38766 13.3332 4.16665C13.3332 3.94563 13.2454 3.73367 13.0891 3.57739C12.9328 3.42111 12.7209 3.33331 12.4998 3.33331C12.2788 3.33331 12.0669 3.42111 11.9106 3.57739C11.7543 3.73367 11.6665 3.94563 11.6665 4.16665Z",
    stroke: "#6C59E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.6665 10C11.6665 10.221 11.7543 10.433 11.9106 10.5893C12.0669 10.7456 12.2788 10.8334 12.4998 10.8334C12.7209 10.8334 12.9328 10.7456 13.0891 10.5893C13.2454 10.433 13.3332 10.221 13.3332 10C13.3332 9.77901 13.2454 9.56705 13.0891 9.41076C12.9328 9.25448 12.7209 9.16669 12.4998 9.16669C12.2788 9.16669 12.0669 9.25448 11.9106 9.41076C11.7543 9.56705 11.6665 9.77901 11.6665 10Z",
    stroke: "#6C59E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M11.6665 15.8333C11.6665 16.0543 11.7543 16.2663 11.9106 16.4226C12.0669 16.5789 12.2788 16.6667 12.4998 16.6667C12.7209 16.6667 12.9328 16.5789 13.0891 16.4226C13.2454 16.2663 13.3332 16.0543 13.3332 15.8333C13.3332 15.6123 13.2454 15.4004 13.0891 15.2441C12.9328 15.0878 12.7209 15 12.4998 15C12.2788 15 12.0669 15.0878 11.9106 15.2441C11.7543 15.4004 11.6665 15.6123 11.6665 15.8333Z",
    stroke: "#6C59E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrag);
export default __webpack_public_path__ + "static/media/icon_drag.0e9856d60db6205d1901aafe1e7f0eee.svg";
export { ForwardRef as ReactComponent };